export const SPOTLIGHT_SCREEN_NAME = 'proformaIssueViewQuickAddFormChangeboardingSpotlight';
export const SPOTLIGHT_ID = 'proforma-issue-view-quick-add-form-changeboarding-spotlight';
export const SPOTLIGHT_TARGET_ID =
	'proforma-issue-view-quick-add-form-changeboarding-spotlight-target';
